import { render, staticRenderFns } from "./EditRate.vue?vue&type=template&id=5f0ab2ca&scoped=true&"
import script from "./EditRate.vue?vue&type=script&lang=js&"
export * from "./EditRate.vue?vue&type=script&lang=js&"
import style0 from "./EditRate.vue?vue&type=style&index=0&id=5f0ab2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ab2ca",
  null
  
)

component.options.__file = "EditRate.vue"
export default component.exports